/**
 * @desc 查询sku的最大报价
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierQuotationSearchDto, options?: any) {
  return updateResponse(
    http(URL + `/searchSupplierMaxQuotation`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
